<template>
  <div class="evalateitem">
    <div class="evalateitem-top flexsb">
      <div class="evalateitem-top-left flexfs">
        <img src="@/assets/img/avatar.png" alt="" />
        <div class="ml-16">
          <p class="fontbig fontdark">{{ item.name }}</p>
          <p class="font12 mt-4">{{ item.createTime }}</p>
        </div>
      </div>
      <div class="evalateitem-top-right">
        <span>评分：</span>
        <Rate disabled show-text allow-half v-model="item.score">
          <span style="color: #f5a623">{{ item.score }}分</span>
        </Rate>
      </div>
    </div>
    <div class="evalateitem-btm">
      <div class="evalateitem-btm-left">
        <p class="lineBreak">{{ item.content }}</p>
      </div>
      <div class="evalateitem-btm-right">
        <div
          class="btnblue mr-10 mb-10 font12"
          v-for="(ele, index) in item.tags"
          :key="index"
        >
          {{ ele }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
    let self = this;
  },
  methods: {},
};
</script>

<style lang="scss">
.evalateitem {
  border-bottom: 1px solid #f6f7f9;
  padding: 24px 0;
  &-top {
    &-left {
      color: #919caf;
      img {
        width: 48px;
      }
    }
  }
  &-btm {
    padding-left: 64px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    color: #67799c;
    &-left {
      width: 480px;
    }
    &-right {
      width: 258px;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
    }
  }
}
</style>
